// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"KQVC7","field":"KiCnH","label":"UFCYT"};